//Stripe statuses
export const SUCCEEDED = 'succeeded';
export const PROCESSING = 'processing';
export const REQUIRES_ACTION = 'requires_action';
export const REQUIRES_CONFIRMATION = 'requires_confirmation';

//Stripe statuses treated as successful
export const successfulStatuses = [
  REQUIRES_CONFIRMATION,
  REQUIRES_ACTION,
  PROCESSING,
  SUCCEEDED
];

//Default
export const DEFAULT_PAYMENT_METHOD = 'card';

//Stripe appearance settings
export const stripeAppearance = {
  theme: 'stripe',
  variables: {
    borderRadius: '8px',
    colorDanger: '#FF6E6E',
    colorText: '#667085',
    fontSizeSm: '14px'
  },
  rules: {
    '.Input::placeholder': { color: '#aaafb7', fontWeight: '400' },
    '.Input:focus': {
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07), 0 0 0 2px #1361D8'
    },
    '.Input--invalid': {
      border: '1px'
    },
    '.Input--invalid:focus': {
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07), 0 0 0 2px #f04438',
      borderColor: 'transparent'
    },
    '.Label': {
      fontWeight: '500',
      marginBottom: '8px'
    },
    '.Error': {
      marginTop: '8px'
    }
  }
};

export const createPaymentElementAppearance = (primaryColor = '#1361d8') => ({
  theme: 'stripe',
  variables: {
    colorPrimary: primaryColor,
    ...stripeAppearance.variables
  },
  rules: {
    ...stripeAppearance.rules,
    '.Tab': { colorBackground: primaryColor, colorText: '#667085' },
    '.Tab--selected': {
      borderColor: primaryColor,
      backgroundColor: primaryColor,
      color: '#ffffff',
      fontWeight: '600',
      border: 'none'
    },
    '.Tab--selected:focus': {
      borderColor: primaryColor,
      backgroundColor: primaryColor,
      color: '#ffffff',
      fontWeight: '600',
      border: 'none'
    },
    '.Tab--selected:active': {
      borderColor: primaryColor,
      backgroundColor: primaryColor,
      color: '#ffffff',
      fontWeight: '600',
      border: 'none'
    },
    '.Tab:hover': {
      borderColor: primaryColor,
      cursor: 'pointer',
      colorText: '#667085'
    },
    '.Tab--selected:hover': {
      borderColor: primaryColor,
      color: '#ffffff',
      border: 'none'
    },
    '.TabIcon': { colorText: 'red' },
    '.TabIcon--selected': { fill: '#ffffff' }
  }
});

// Tenant domains that require full billing address (e.g., India cross-border payments)
/** @type {string[]} */
const DOMAINS_REQUIRING_FULL_ADDRESS = [
  // TODO: This is the quick & dirty version, see XGE-2634 for root cause and next steps/"do it right"
  'breathedreamgo.qa.softripng.com', // BreatheDreamGo in QA
  'breathedreamgo.softripng.com', // BreatheDreamGo in PRODUCTION
  'dev.softrip.com'
];

/**
 * Check if the current tenant requires full billing address collection
 * Determines this by checking the current page's domain
 * @returns {boolean} True if current tenant requires full address
 */
export const requiresFullBillingAddress = () => {
  try {
    // Safety check for SSR or non-browser environments
    if (typeof window === 'undefined' || !window.location) {
      return false;
    }

    const currentDomain = window.location.hostname;
    const requiresFullAddress =
      DOMAINS_REQUIRING_FULL_ADDRESS.includes(currentDomain);
    return requiresFullAddress;
  } catch (error) {
    // If anything fails, default to NOT requiring full address
    // This prevents breaking the payment flow for other tenants
    console.error('Error checking billing address requirement:', error);
    return false;
  }
};

// Stripe PaymentElement config
export const paymentElementOptions = {
  layout: 'tabs',
  paymentMethodOrder: [],
  fields: {
    // Skip name and email since we collect that ourselves then push to the payment intent
    billingDetails: {
      name: 'never',
      email: 'never'
    }
  }
};
